import {Dispatch, SetStateAction} from 'react'

export type PublicKey = undefined | null | string

export type ID = undefined | null | number

export type PaginationState = {
  offset: number
  page?: number
  limit: number | 10 | 30 | 50 | 100
  links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
  last_page?: number
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: unknown
}

export type SearchState = {
  search?: string
}

export type Response<T> = {
  result?: T
  filters?: {
    count?: number
    limit?: number
    offset?: number
  }
  data?: T
  payload?: {
    message?: string
    errors?: {
      [key: string]: Array<string>
    }
    pagination?: PaginationState
  }
}

export type QueryState = PaginationState & SortState & FilterState & SearchState

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export const initialQueryState: QueryState = {
  offset: 1,
  limit: 10,
}

export const initialQueryStateImport: QueryState = {
  offset: 1,
  limit: 5,
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
  setQuery?: React.Dispatch<React.SetStateAction<string>>
}

export const initialQueryResponse = {refetch: () => {}, isLoading: false, query: ''}

export type ListViewContextProps = {
  selected: Array<PublicKey>
  onSelect: (selectedId: PublicKey) => void
  onSelectAll: () => void
  clearSelected: () => void
  workAuthorization?: {} | any
  handleAddAuthPublicKey?: (publicKey: any, value: boolean) => void | any
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: PublicKey
  authSelected?: []
  setAuthSelected?: Dispatch<SetStateAction<any>>
  setItemIdForUpdate: Dispatch<SetStateAction<PublicKey>>
  isAllSelected: boolean
  disabled: boolean
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  setAuthSelected: () => {},
  isAllSelected: false,
  disabled: false,
}
